import * as React from 'react';
import SearchOutlined from '@ant-design/icons/SearchOutlined';
import { Input } from '../../../Input';
var FilterSearch = function FilterSearch(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    filterSearch = _ref.filterSearch,
    tablePrefixCls = _ref.tablePrefixCls;
  if (!filterSearch) {
    return null;
  }
  return React.createElement("div", {
    className: "".concat(tablePrefixCls, "-filter-dropdown-search")
  }, React.createElement(Input, {
    prefix: React.createElement(SearchOutlined, null),
    placeholder: "\u5728\u7B5B\u9009\u9879\u4E2D\u641C\u7D22",
    onChange: onChange,
    value: value,
    className: "".concat(tablePrefixCls, "-filter-dropdown-search-input")
  }));
};
export default FilterSearch;